module.exports = __webpack_public_path__ + "img/beerstorium-logo.92c08726.png";